import { render, staticRenderFns } from "./DocumentLogin.vue?vue&type=template&id=28ea6e40&scoped=true"
import script from "./DocumentLogin.vue?vue&type=script&lang=js"
export * from "./DocumentLogin.vue?vue&type=script&lang=js"
import style0 from "./DocumentLogin.vue?vue&type=style&index=0&id=28ea6e40&prod&lang=scss"
import style1 from "./DocumentLogin.vue?vue&type=style&index=1&id=28ea6e40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea6e40",
  null
  
)

export default component.exports